import { render, staticRenderFns } from "./video_tutorials.vue?vue&type=template&id=0f82dbec&scoped=true"
import script from "./video_tutorials.vue?vue&type=script&lang=js"
export * from "./video_tutorials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f82dbec",
  null
  
)

export default component.exports